/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    PageTitle: {
        id: 'qnb.common.yourCreditExplained.PageTitle',
        defaultMessage: 'Your Credit Explained'
    },
    ByOpting: {
        id: 'qnb.common.yourCreditExplained.ByOpting',
        defaultMessage: 'By opting to pay your insurance by monthly Direct Debit, you are applying for credit from us in the form of a credit agreement. By entering into the credit agreement with us, you will be agreeing to repay the insurance premium by way of monthly repayments. This credit is an ancillary product offered in conjunction with your Saga {appName} Insurance only. It is possible to buy Saga {appName} Insurance without credit, but it is not possible to enter into a credit agreement with Saga unless you are buying Saga Insurance.'
    },
    IfYouPurchase1: {
        id: 'qnb.common.yourCreditExplained.IfYouPurchase1',
        defaultMessage: 'If you purchase the policy without entering into the credit agreement, the total cost of the policy to you will be '
    },
    IfYouPurchase2: {
        id: 'qnb.common.yourCreditExplained.IfYouPurchase2',
        defaultMessage: '. If you purchase the policy on credit, the total cost to you, including the cost of the credit will be '
    },
    IfYouPurchase3: {
        id: 'qnb.common.yourCreditExplained.IfYouPurchase3',
        defaultMessage: '. This means you will be paying an extra '
    },
    IfYouPurchase4: {
        id: 'qnb.common.yourCreditExplained.IfYouPurchase4',
        defaultMessage: ' to pay monthly.'
    },
    YourPreContact: {
        id: 'qnb.common.yourCreditExplained.YourPreContact',
        defaultMessage: 'Your Pre-Contract Credit Information will be provided in your policy documents; please read this carefully as it sets out key details about your credit. It is important that you consider this document carefully and ensure you understand what is involved in entering into a credit agreement. Please let us know if you have any questions once you have considered this (our phone number is below).'
    },
    IsThisCreditSuitable: {
        id: 'qnb.common.yourCreditExplained.IsThisCreditSuitable',
        defaultMessage: 'Is this credit suitable for you?'
    },
    TheCreditBeingProvided: {
        id: 'qnb.common.yourCreditExplained.TheCreditBeingProvided',
        defaultMessage: 'The credit is being provided to finance the insurance policy premium. If you wish to pay for the insurance policy premium upfront in one payment, this credit will not be suitable for you.'
    },
    HowWillCreditWork: {
        id: 'qnb.common.yourCreditExplained.HowWillCreditWork',
        defaultMessage: 'How will the credit work?'
    },
    InterestRateIsFixed: {
        id: 'qnb.common.yourCreditExplained.InterestRateIsFixed',
        defaultMessage: 'As the interest rate is fixed, the monthly repayments will be fixed amounts. You will repay your credit in {numberOfInstallments} monthly instalments, with the first instalment due on '
    },
    HowMuchWillCreditCost: {
        id: 'qnb.common.yourCreditExplained.HowMuchWillCreditCost',
        defaultMessage: 'How much will the credit cost?'
    },
    SeeRepresentativeExample: {
        id: 'qnb.common.yourCreditExplained.SeeRepresentativeExample',
        defaultMessage: 'See the Representative Example for details of the monthly cost and the number and amount of repayments you will have to pay under the credit agreement, the interest rate applicable and the total amount you will have to pay over the duration of the agreement. This information is also set out in your Pre Contract Credit Information and in your credit agreement under the heading “Key Financial Information”, which will be provided in your policy documents.'
    },
    KeepingUpWithRepayments: {
        id: 'qnb.common.yourCreditExplained.KeepingUpWithRepayments',
        defaultMessage: 'Keeping up with your repayments'
    },
    IfYouMissRepayment: {
        id: 'qnb.common.yourCreditExplained.IfYouMissRepayment',
        defaultMessage: 'If you miss a repayment, we may end your credit agreement, after giving you any notice required by law. If we do this and you do not pay the outstanding premium for your insurance policy, your insurance policy will also be terminated.'
    },
    MissingPayments: {
        id: 'qnb.common.yourCreditExplained.MissingPayments',
        defaultMessage: 'Missing payments could have severe consequences for your finances and could lead to the amount you owe us under the credit agreement increasing, as we may charge you interest on any unpaid amount from its due date until the date of actual payment, together with our costs incurred in enforcing the agreement.'
    },
    ObtainingCredits: {
        id: 'qnb.common.yourCreditExplained.ObtainingCredits',
        defaultMessage: 'It may make obtaining credit more difficult in the future as we may report non-payment to credit reference agencies (which most lenders consult when assessing any borrowing application) and this will adversely affect your credit rating.'
    },
    RightOfWithdrawal: {
        id: 'qnb.common.yourCreditExplained.RightOfWithdrawal',
        defaultMessage: 'Right of withdrawal'
    },
    YouHaveRightToWithdrawal: {
        id: 'qnb.common.yourCreditExplained.YouHaveRightToWithdrawal',
        defaultMessage: 'You have a right to withdraw from the credit agreement after it has been made within 15 days from the day you receive your copy of it. If you would like to withdraw from the credit agreement at any time, please call us on {phoneNumber} or write to us at the address shown on the credit agreement. You will need to repay the outstanding balance of your insurance policy by credit or debit card within 30 calendar days from the day you give us notice that you wish to withdraw from the credit agreement. Saga will stop charging interest from the day you notify us that you would like to withdraw from the credit agreement.'
    },
    IfYouWithdraw: {
        id: 'qnb.common.yourCreditExplained.IfYouWithdraw',
        defaultMessage: 'Please note: if you withdraw, you will continue to be covered under your policy as long as you pay the full premium within 30 calendar days. Otherwise, your policy will also end. If you withdraw or otherwise cancel or end your credit agreement and do not pay your insurance premium by an alternative means, your related insurance policy may be cancelled and you will no longer be insured. We are happy to answer any question you may have about the loan. Please contact us on {phoneNumber}.'
    },
    PrintPage: {
        id: 'qnb.common.yourCreditExplained.PrintPage',
        defaultMessage: 'Print'
    },
    PayingByInstalmentsPayNowButton: {
        id: 'qnb.common.yourCreditExplained.payingByInstalmentsPayNowButton',
        defaultMessage: 'Pay now'
    },
    docuSignCheckboxLabel: {
        id: 'qnb.common.yourCreditExplained.docuSignCheckboxLabel',
        defaultMessage: 'Please tick this box to confirm you\'ve chosen to pay by monthly Direct Debit and enter into a credit agreement with Saga'
    },
    docuSignValidationMessage: {
        id: 'qnb.common.yourCreditExplained.docuSignValidationMessage',
        defaultMessage: 'To purchase this policy and pay by monthly instalments you will need to enter into the credit agreement with Saga. Please tick the box to confirm you agree to the terms of the credit agreement or, alternatively, go back and choose a different payment method.'
    },
    YourCreditExplainedHeader: {
        id: 'qnb.common.yourCreditExplained.YourCreditExplainedHeader',
        defaultMessage: 'Your credit explained'
    }
});
